import { useNavigate } from 'react-router';

import { SoftwareOnboardingHeader, SoftwareOnboardingProgress } from 'src/components/SoftwareOnboarding';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { getRequestChangesExitPath } from 'src/pages/SoftwareEscrowRequestChanges/lib';
import { SoftwareEscrowRequestChangesRoutesEnum } from 'src/pages/SoftwareEscrowRequestChanges/model';
import { useNotificationsSuggestChanges } from 'src/context/suggest-changes';
import { ExitAlertDialog } from 'src/pages/SoftwareEscrowRequestChanges/ui';

const Header = () => {
  const { steps, currentStep } = useNotificationsSuggestChanges();
  const navigate = useNavigate();
  const {
    softwareEscrow: { id },
  } = useSoftwareEscrow();

  const onDiscardChanges = () =>
    navigate(getRequestChangesExitPath(id, SoftwareEscrowRequestChangesRoutesEnum.Technical));

  return (
    <SoftwareOnboardingHeader justify="end">
      {steps.length > 1 && <SoftwareOnboardingProgress currentStep={currentStep + 1} totalSteps={steps.length} />}
      <ExitAlertDialog onDiscard={onDiscardChanges} />
    </SoftwareOnboardingHeader>
  );
};

export default Header;
